export default __webpack_public_path__ + "static/media/cert-senior-manager-consumer.df401697.jpg";